import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';
import { ReceiptText } from 'lucide';

/**
 * Intake affordance (HS2-FKJB32): when a document uploaded as `supporting` was
 * classified as a vendor quotation (see `looksLikeVendorQuotation`), the
 * supporting-docs tile offers to add it as a quote. The click is delegated in
 * init.ts to `reclassifyDocAsQuote(docId)`, which flips the document's kind and
 * runs it through the quote-extract pipeline; on success it appears under Quotes.
 */
export function DocQuoteOffer({ docId }: { docId: string }): SafeHtml {
  return (
    <List className="doc-quote-offer" hAlign="center" gap="2xs">
      <Text variant="span" tone="quiet" size="compact">
        Looks like a vendor quotation.
      </Text>
      <Button
        size="compact"
        tone="brand"
        emphasis="primary"
        action="reclassify-quotation"
        icon={<LucideIcon icon={ReceiptText} name="" />}
        rootAttributes={{ 'data-doc-id': docId }}
      >
        Add as Quote
      </Button>
    </List>
  );
}
